import { FormHelperText } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { getIn, useField, useFormikContext } from "formik";
import { useEffect } from "react";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

const FormikRadio = ({ caseInsensitive = false, children, ...props }) => {
  const [field, meta] = useField(props);
  const { values, setFieldValue } = useFormikContext();
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);

  const fieldValue = getIn(values, props.name);

  useEffect(() => {
    if (props.callBack) {
      props.callBack(fieldValue);
    }
  }, [fieldValue]);

  useEffect(() => {
    if (caseInsensitive) {
      const value = children?.find(
        (child) =>
          child?.props?.value?.toLowerCase() === props.value?.toLowerCase(),
      )?.props.value;

      if (value) setFieldValue(props.name, value);
    }
  }, []);

  return (
    <FormControl
      sx={props.sx ?? {}}
      component="fieldset"
      error={meta.touched && meta.error ? true : false}
      disabled={props.disabled}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        name={props.name}
        value={props.value}
        row={props.row}
        {...field}>
        {children}
      </RadioGroup>
      <FormHelperText>
        {meta.touched && meta.error ? meta.error : null}
      </FormHelperText>
    </FormControl>
  );
};

export default FormikRadio;
